import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  project: Boundaries["removeProject"]["request"],
): State {
  return [...state, { project, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  project: Boundaries["removeProject"]["success"],
): State {
  return state.map((item) =>
    item.project.uuid === project.uuid
      ? { project, request: setRequestStateToSuccess() }
      : item,
  );
}

function handleFailure(
  state: State,
  { project }: Boundaries["removeProject"]["failure"],
): State {
  return state.map((item) =>
    item.project.uuid === project.uuid
      ? { project, request: setRequestStateToFailure() }
      : item,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeProjectRequested]: handleRequest,
    [events.removeProjectSucceeded]: handleSuccess,
    [events.removeProjectFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
